import { Component, inject } from "@angular/core";
import { UpdatePasswordFormModel } from "../../models/password-form.model";
import { ReactiveFormsModule } from "@angular/forms";
import { PasswordInputComponent } from "@app/kernel/form/modules/inputs/simple-inputs/components/password-input/password-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-update-password-form",
  standalone: true,
  imports: [ReactiveFormsModule, PasswordInputComponent, TranslateModule, CommonModule],
  templateUrl: "./update-password-form.component.html",
  styleUrls: ["./update-password-form.component.scss"],
})
export class UpdatePasswordFormComponent {
  readonly formModel = inject(UpdatePasswordFormModel);
}
